import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/services/auth.service';

@Component({
  selector: 'app-menu-pedido',
  templateUrl: './menu-pedido.component.html',
  styleUrls: ['./menu-pedido.component.scss'],
})
export class MenuPedidoComponent implements OnInit {

  constructor(
    
    private authService: AuthService,
    private router: Router,

  ) { }

  async CheckIsLoggedIn() {
    let userDatos = await this.authService.GetCurrentUser();
    if(userDatos==false){
      this.router.navigate(['/login']);
    }
  }


  ngOnInit() {
    
    this.CheckIsLoggedIn();
  }

}
